<template>
    <div :class="'dropdown ' + customClass">
        <v-button
            :customId="customId"
            :customClass="'dropdown__dropdown-btn'"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            :customLabel="filters.dict(customLabel)"
            :svg="svg"
            :svgAlt="svgAlt"
            :disabled="disabled"
        />
        <div class="dropdown-menu" :class="{'dropdown-menu-right': menuRight}" :aria-labelledby="customId">
            <a
                class="dropdown-item"
                href
                @click.prevent="handleClick(customSelection)"
                :key="customId + '-custom-selection'"
                :class="{'active': customSelection.value == activeDropdownValue}"
                v-if="customSelection">{{filters.dict(customSelection.name)}}</a>
            <a
                class="dropdown-item"
                href
                @click.prevent="handleClick(dropdown)"
                v-for="(dropdown, dropdownIndex) in sortedDropdownData"
                :key="customId + dropdownIndex"
                :class="{'active': (activeDropdownValue && dropdown.value == activeDropdownValue) || (!activeDropdownValue && dropdown.value == activeDropdownValue)}">{{filters.dict(dropdown.name)}}</a>
        </div>
    </div>
</template>

<script>
import bus from '@/js/event-bus.js';

export default {
    name: 'v-dropdown',
    props: {
        customId: {
            type: String,
            default: '',
            required: true
        },
        customClass: {
            type: String,
            default: ''
        },
        customLabel: {
            type: String,
            default: 'Dropdown',
            required: true
        },
        dropdownData: {
            type: Array,
            required: true
        },
        activeDropdownValue: {
            default: null
        },
        customSelection: {
            default: null
        },
        customSortDir: {
            type: String,
            default: 'desc'
        },
        selectedValueField: {
            type: String,
        },
        svg: {
            type: String
        },
        svgAlt: {
            type: String
        },
        menuRight: {
            type: Boolean
        },
        disabled: {
            type: Boolean
        }
    },
    data () {
        return {
            filters: window.filters 
        }
    },
    computed: {
        sortedDropdownData: function () {
            return _.orderBy(this.dropdownData, null, this.customSortDir);
        }
    },
    mounted () {
        $(this.$el).hover(function () {
            if ($(this).siblings().hasClass('show')) {
                $(this).find('.dropdown__dropdown-btn').dropdown('toggle');
            }
        });
    },
    methods: {
        handleClick (data) {
            bus.$emit('filter:click', {
                'selectedValueField': this.selectedValueField,
                'value': data.value
            });
        }
    }
};
</script>

<style lang="scss">
.dropdown {
    display: inline-block;
    margin-right: 10px;
}

.dropdown-menu {
    max-height: 200px;
    overflow: auto;
    .dropdown-item {
        padding: 0.25rem 1.5rem;
        text-align: left;

        &.active {
            color: #FFFFFF;
            text-decoration: none;
            background-color: #015496;
        }
    }
}
</style>

